<template>
    <div>
        <div class="userInfo">
            <div class="left">
                <div class="header">
                    <div class="user">
                        <img class="avatar" v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" alt="头像" />
                        <img class="avatar" v-else src="@/assets/default_avatar.png" alt="头像" />

                        <div>
                            <div class="name">{{ userInfo.nickName }}（技巧师）</div>
                            <div class="content">
                                <div>
                                    <div>双色球：{{ userInfo.doubleColorBall || 0 }}</div>
                                    <div>大乐透：{{ userInfo.lottery || 0 }}</div>
                                    <div class="lastDiv">缩水列表</div>
                                </div>
                                <div>
                                    <div>福彩3D：{{ userInfo.fucai3d || 0 }}</div>
                                    <div>体彩排三：{{ userInfo.pailieSan || 0 }}</div>
                                    <div class="lastDiv">历史成绩</div>
                                </div>
                                <div>
                                    <div>缩币文章</div>
                                    <div>浏览人数</div>
                                    <div class="lastDiv">加入关注</div>
                                </div>
                                <div>
                                    <div>免费预测</div>
                                    <div>粉丝人数</div>
                                    <div class="lastDiv">放入桌面</div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="right">
                <div v-for="(item, index) in right.arr" :key="index" :class="right.active === index ? 'active' : ''"
                    @click="right.active = index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="table">
            <div class="tit">
                <div>
                    近期成绩
                    <span :class="currentLottery === 0 ? 'active' : ''" @click="switchLottery(0)">双色球</span>
                    <span :class="currentLottery === 2 ? 'active' : ''" @click="switchLottery(2)">福彩3D</span>
                    <span :class="currentLottery === 1 ? 'active' : ''" @click="switchLottery(1)">大乐透</span>
                    <span :class="currentLottery === 3 ? 'active' : ''" @click="switchLottery(3)">排列三</span>
                </div>
                <div>
                    <span :class="currentPeriod === 'history' ? 'active' : ''"
                        @click="currentPeriod = 'history'; getTechnicianResults()">历史</span>
                    <span :class="currentPeriod === 'recent' ? 'active' : ''"
                        @click="currentPeriod = 'recent'; getTechnicianResults()">近20期</span>
                </div>
            </div>
            <div class="grid" v-if="!loading">
                <div>
                    <span>期号</span>
                    <span>成绩</span>
                    <span>命中红球</span>
                    <span>命中蓝球</span>
                    <span>红+蓝</span>
                    <span>准确率</span>
                    <span>连续命中</span>
                    <span>最大连中</span>
                </div>
                <div v-for="(item, index) in resultList" :key="index">
                    <span>{{ item.number || '-' }}</span>
                    <span>{{ item.achievment || '-' }}</span>
                    <span>{{ item.redTotal || '-' }}</span>
                    <span>{{ item.blueTotal || '-' }}</span>
                    <span>{{ item.redBlueTotal || '-' }}</span>
                    <span>{{ item.accuracy || '-' }}</span>
                    <span>{{ item.currentContinuousRight || '-' }}</span>
                    <span>{{ item.continuousRightMax || '-' }}</span>
                </div>
                <div v-if="resultList.length === 0">
                    <span colspan="8" style="grid-column: 1/-1;">暂无数据</span>
                </div>
            </div>
            <div v-else class="loading">
                <div class="spinner"></div>
                <span>加载中...</span>
            </div>
        </div>
    </div>
</template>

<script>
import { getInfo, techScore } from "@/api/hangjiaguanli";

export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},
            resultList: [],
            currentLottery: 0, // 0:双色球, 1:大乐透, 2:福彩3D, 3:排列三
            currentPeriod: 'recent', // history:历史, recent:近20期
            loading: false,

            right: {
                arr: [
                    { name: "缩水单大厅" },
                    { name: "EXCEL专区" },
                    { name: "缩水软件专区" },
                    { name: "实体投注站帮扶中心" },
                ],
                active: 0
            }
        };
    },
    mounted() {
        this.getUserInfo();
        this.getTechnicianResults();
    },
    methods: {
        getUserInfo() {
            getInfo({
                userId: this.vuex_userInfo.userId,
            }).then(res => {
                this.userInfo = res.data;
            })
        },
        switchLottery(type) {
            this.currentLottery = type;
            this.getTechnicianResults();
        },
        getTechnicianResults() {
            this.loading = true;
            techScore({
                preType: this.currentLottery,
                preIndexType: "1",
                createUser: this.vuex_userInfo.userId,
                createUserType: "1"
            }).then(res => {
                console.log(res);
                this.resultList = res.rows || [];
            }).catch(err => {
                console.error('获取技巧师成绩失败:', err);
                this.resultList = [];
            }).finally(() => {
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.userInfo {
    display: flex;

    .left {
        flex: 1;

        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);

            .user {
                display: flex;

                .avatar {
                    width: 100px;
                    height: 100px;
                    border-radius: 10px;
                    margin-right: 10px;
                    border: 1px solid #eee;
                }

                >div {
                    flex: 1;

                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }

                    .content {
                        display: flex;
                        justify-content: space-between;

                        .lastDiv {
                            margin-top: 15px;
                            background-color: #93d2f3;
                            padding: 5px 10px;
                            cursor: pointer;
                        }
                    }
                }
            }

            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;

                >div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }
    }

    .right {
        text-align: center;
        margin-left: 10px;
        width: 200px;
        border: 1px solid rgba(0, 0, 0, 0.2);

        >div {
            font-weight: bold;
            font-size: 13px;
            color: #bd312a;
            padding: 8px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;

            &.active {
                background-color: #93d2f3;
            }
        }
    }
}

.table {
    .tit {
        background-color: #93d2f3;
        color: #bd312a;
        display: flex;
        justify-content: space-between;

        span {
            display: inline-block;
            padding: 10px;
            cursor: pointer;

            &.active {
                background-color: #bd312a;
                color: #fff;
            }
        }
    }

    .grid {
        >div {
            display: grid;
            text-align: center;
            grid-template-columns: repeat(8, 1fr);

            span {
                border: 1px solid rgba(0, 0, 0, 0.1);
                padding: 10px 0;
            }
        }
    }

    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px;
        color: #bd312a;

        .spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #bd312a;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-bottom: 10px;
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>